import { render, staticRenderFns } from "./EditDirection.vue?vue&type=template&id=dd514970"
import script from "./EditDirection.vue?vue&type=script&lang=js"
export * from "./EditDirection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports